import { EXPORTAR_FECHAMENTOS_CAIXA } from '../../actions/types'

const initialState = {
    exportando: false,
    fechamentosExportados: []
}

export default function reducerExportarFechamentosCaixa(state = initialState, action) {
    switch (action.type) {
        case EXPORTAR_FECHAMENTOS_CAIXA: {
            return {
                ...state,
                exportando: false,
                fechamentosExportados: action.payload.fechamentos || []
            }
        }

        default: {
            return state
        }
    }
}
